import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET the queue of pending Material Receipts (MRR) for this user
export const getTransferRecieptDetails = async (Roleid, UId) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetTransferRecieptDetails?Roleid=${encodeURIComponent(Roleid)}&UId=${encodeURIComponent(UId)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the item-level detail grid for one pending receipt. Type is either
// "From Other Store" (internal stock transfer) or "From Vendor" (PO receipt) —
// the row shape differs accordingly (see TransferReciept.jsx).
export const getTransferRecieptDataGrid = async (Refno, Type, POType) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetTransferRecieptDataGrid?Refno=${encodeURIComponent(Refno)}&Type=${encodeURIComponent(Type)}&POType=${encodeURIComponent(POType || '')}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// PUT — finalize an internal ("From Other Store") stock-transfer receipt
// payload: { Rid, ICCCodes, ItemCodes, Amts, IssuedQtys, LostQtys, DamagedQtys,
//            SumLostQty, SumDamagedQty, RefNo, Date, Type, IndentNo, Remarks,
//            CreatedBy, Roleid }
export const saveTransferReciept = async (payload) => {
    try {
        const res = await axios.put(
            `${API_BASE_URL}/Purchase/SaveTransferReciept`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// PUT — finalize a vendor PO receipt (MRR)
// payload: { Rid, ItemCodes, RecievedQty, Basic, Date, Remarks, SumRecievedQty,
//            SumRaisedQty, PoNo, CreatedBy, Roleid, Filechk, Extension }
export const saveVendorTransferReciept = async (payload) => {
    try {
        const res = await axios.put(
            `${API_BASE_URL}/Purchase/SaveVendorTransferReciept`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};
